<ng-container>
  <app-data-table [columns]="cols" [data]="system" [isCardView]="false" (onPresentView)="getSystem()" [url]="'/master/section-master/'"
    [isDeletable]="'/master/section' | hasPermission: 'Delete'"  [showAddButton]="'/master/section' | hasPermission: 'Add'" [showActions]="canEditSetup" [isEditable]="'/master/section' | hasPermission: 'Edit'"   [title]="title" (onAdd)="addSystem()" (editEventRow)="updateSystem($event)" [isView]="'/master/section' | hasPermission: 'View'" (viewEventRow)="viewSystem($event)"
    (deleteEventRow)="showDeletePopup($event)" (onLazyLoadData)="getSystem($event)" [totalRecords]="totalRecords">
  </app-data-table>
</ng-container>

<!-- Create Section Dialog -->
<app-reusable-dialog
  [(visible)]="showDialog"
  [config]="createDialogConfig"
  [initialData]="initialData"
  [viewMode]="false"
  (onSubmit)="onCreateSubmit($event)"
  (onCancel)="onDialogCancel()"
  (onClose)="onDialogClose()"
></app-reusable-dialog>



<!-- Update/View Section Dialog -->
<app-reusable-dialog
  [(visible)]="isUpdatedialog"
  [config]="updateDialogConfig"
  [initialData]="initialData"
  [viewMode]="viewMode"
  (onSubmit)="onUpdateSubmit($event)"
  (onCancel)="onDialogCancel()"
  (onClose)="onDialogClose()"
></app-reusable-dialog>


<p-dialog header="Delete Section" [modal]="true" [(visible)]="showDeleteDialog" [style]="{ width: '30rem' }" [maximizable]="true">
  <div class="delete-dialog text-center mt-3">
    <i class="pi pi-trash text-danger custom-delete-icon"></i>
    <span>Are you sure , you want to delete section ?</span>
    <p-button label="Delete" icon="pi pi-trash" severity="danger" [outlined]="true" (click)="deleteSystem()" class="mt-2">
    </p-button>
  </div>
</p-dialog>